import { render } from "./Referal.vue?vue&type=template&id=3e60bb40&scoped=true"
import script from "./Referal.vue?vue&type=script&lang=js"
export * from "./Referal.vue?vue&type=script&lang=js"

import "./Referal.vue?vue&type=style&index=0&id=3e60bb40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e60bb40"]])

export default __exports__